






import { Component, Vue } from "vue-property-decorator";
import AuditKuantitatifRmeList from "@/components/mrmik/audit-kuantitatif-rme/AuditKuantitatifRmeList.vue";

@Component({
  components: { AuditKuantitatifRmeList }
})
export default class AuditKuantitatifRmePage extends Vue {}
